export enum MapActionsLoading {
    NOME_MODULO = 'loading',
    OPEN_LOADING = 'openLoading',
    CLOSE_LOADING = 'closeLoading',
}

export class MapActionsLoadingModule {
    static OPEN_LOADING = `${MapActionsLoading.NOME_MODULO}/${MapActionsLoading.OPEN_LOADING}`;
    static CLOSE_LOADING = `${MapActionsLoading.NOME_MODULO}/${MapActionsLoading.CLOSE_LOADING}`;
}
